import React, { useEffect } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Swiper, { Navigation, Pagination } from 'swiper';
import { Icons } from '@src/common/Icons';

Swiper.use([Navigation, Pagination]);

const SlideSwiper = () => {

    useEffect(() => {
        new Swiper('#swiper3', {
            autoplay: true,
            navigation: {
                prevEl: '#prev3',
                nextEl: '#next3'
            },
            pagination: {
                el: '#pagination3',
                type: 'fraction'
            }
        });
    }, []);

    return (
        <div>

            <div className={styles.swiper3}>
                <div className="swiper" id="swiper3">
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <div className={styles.swiperItem}>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Ck3oDOmIzF" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['短道速滑']} alt="短道速滑" />
                                    </div>
                                    <span>短道速滑</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjsNP6Kspw" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['速度滑冰']} alt="速度滑冰" />
                                    </div>
                                    <span>速度滑冰</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjtrG7KiEP" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['花样滑冰']} alt="花样滑冰" />
                                    </div>
                                    <span>花样滑冰</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjtpmCzKwx" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['冰球']} alt="冰球" />
                                    </div>
                                    <span>冰球</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Ck3oDOmJ0V" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['冰壶']} alt="冰壶" />
                                    </div>
                                    <span>冰壶</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjuCrCrcy4" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['雪车']} alt="雪车" />
                                    </div>
                                    <span>雪车</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Cjrh4REFgS" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['钢架雪车']} alt="钢架雪车" />
                                    </div>
                                    <span>钢架雪车</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Ck06Ow9bMU" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['雪橇']} alt="雪橇" />
                                    </div>
                                    <span>雪橇</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjruMtRAFk" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['冬季两项']} alt="冬季两项" />
                                    </div>
                                    <span>冬季两项</span>
                                </a>
                            </div>
                        </div>
                        <div className="swiper-slide">
                            <div className={styles.swiperItem}>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Cjrh4REFY2" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['高山滑雪']} alt="高山滑雪" />
                                    </div>
                                    <span>高山滑雪</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjsNP6KskF" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['自由式滑雪']} alt="自由式滑雪" />
                                    </div>
                                    <span>自由式滑雪</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjtrG7cJKn" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['单板滑雪']} alt="单板滑雪" />
                                    </div>
                                    <span>单板滑雪</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjtrG7KiBV" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['跳台滑雪']} alt="跳台滑雪" />
                                    </div>
                                    <span>跳台滑雪</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8Cjrd5o51bS" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['越野滑雪']} alt="越野滑雪" />
                                    </div>
                                    <span>越野滑雪</span>
                                </a>
                                <a className={styles.item} href="https://sports.ifeng.com/c/8CjruMtRA6p" target="_blank" rel="noreferrer">
                                    <div className={styles.imgWp}>
                                        <img src={Icons['北欧两项']} alt="北欧两项" />
                                    </div>
                                    <span>北欧两项</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.page}>
                <div className={styles.prev3} id="prev3" />
                <div className="swiper-pagination3" id="pagination3" />
                <div className={styles.next3} id="next3" />
            </div>
        </div>
    );
};

export default errorBoundary(SlideSwiper);
